// @mui
import { SvgIcon } from "@mui/material";

function CloseIcon(props) {
  const { sx, prop } = props;
  return (
    <SvgIcon width="24" height="24" viewBox="0 0 24 24" sx={{ fill: "transparent", ...sx }} {...prop}>
      <path
        d="M6 6L18 18"
        stroke={props.color || "#07657F"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 6L6 18"
        stroke={props.color || "#07657F"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}

export default CloseIcon;
